import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

interface SkipLinkProps {
  title: string
  to: `#${string}`
}

export default memo(function SkipLink({title, to: href}: SkipLinkProps) {
  return (
    <VisuallyHidden as='a' href={href} className='skip-link'>
      {title}
    </VisuallyHidden>
  )
})
